import { getUserManager } from '../auth/oidcUserManager';
import { getPanelUsersClient } from './api-clients.service';


const login = () => {
    getUserManager().signinRedirect();
}

const getCurrentUser = async () => {
    const client = getPanelUsersClient();
    const response = await client.getCurrentUser();
    return response;
}




export const authenticationService = ({
    Login: login,
    GetCurrentUser: getCurrentUser


})